import { render, staticRenderFns } from "./SubSupplierFormModal.vue?vue&type=template&id=2ebcf804"
import script from "./SubSupplierFormModal.vue?vue&type=script&lang=js"
export * from "./SubSupplierFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports